import { useEffect, useRef, type MouseEvent } from 'react';

// Un double appui sur le bouton qui ouvre la fenêtre (geste courant en plein
// service) retombe sur le fond aussitôt ouvert : sans ce délai, la fenêtre se
// refermait dans la foulée.
export const SCRIM_DISMISS_GRACE_MS = 400;

/**
 * Appui sur le fond d'une fenêtre du ticket = son bouton « Annuler » / « Rester ».
 * Renvoie le `onClick` du fond : n'agit que sur le fond lui-même (un appui dans
 * la carte remonte jusqu'ici), jamais pendant un envoi (`disabled`), jamais
 * dans les `SCRIM_DISMISS_GRACE_MS` qui suivent l'ouverture.
 */
export function useScrimDismiss(open: boolean, onDismiss: () => void, disabled = false) {
  const openedAtRef = useRef(0);
  useEffect(() => {
    if (open) openedAtRef.current = Date.now();
  }, [open]);
  return (e: MouseEvent<HTMLElement>) => {
    if (e.target !== e.currentTarget || disabled) return;
    if (Date.now() - openedAtRef.current < SCRIM_DISMISS_GRACE_MS) return;
    onDismiss();
  };
}
